export const firebaseConfig = {
  apiKey: "AIzaSyDheMZRdX3IEKJCNQOEB6oGQHq8eIJ6wrU",
  authDomain: "latgo-test.firebaseapp.com",
  databaseURL: "https://latgo-test-default-rtdb.firebaseio.com",
  projectId: "latgo-test",
  storageBucket: "latgo-test.appspot.com",
  messagingSenderId: "119226783991",
  appId: "1:119226783991:web:a71b87cafe3a971b21dbf2",
  measurementId: "G-K9ZQLE9EQJ",
  mapApiKey: "AIzaSyDDItfnzQlVebNwTHXjhCMYmuJkOCyK9y8"
};